/* eslint-disable no-eval */
import React, { useEffect, useState } from 'react';
import { FormGroup, Input, UncontrolledTooltip } from 'reactstrap';
import { handleSendGeneric } from 'services/generic';

export const SelectItem = (props) => {
  const [select, setSelect] = useState('');
  const { data, stateChange } = props;

  const handleOnChange = (e) => {
    const itemSeletec = e.target.value;
    const permission = data.filter((value, _) => {
      return value.name === itemSeletec.split('-')[0].trim();
    })[0];
    stateChange(permission.namePermission);
    setSelect(itemSeletec);
  };

  return (
    <FormGroup>
      <Input type='select' onChange={handleOnChange} value={select}>
        <option>Selecione ...</option>
        {data.map((value, key) => {
          return (
            <option key={key}>
              {value.name} - {value.description}
            </option>
          );
        })}
      </Input>
    </FormGroup>
  );
};

export const SelectItemGeneric = ({
  data,
  handleChangeCustom,
  field,
  fieldOriginal,
  nameSelect,
  isMultiple,
  handleChangeTreeValues,
  icon,
  tooltipName,
  descriptionTooltip,
}) => {
  const [select, setSelect] = useState({});
  const [selectMultiple, setSelectMultiple] = useState([]);

  const handleOnChange = (e) => {
    const itemCurrent = e.target.value;

    let itemSelected;
    if (field === 'tableOrder') {
      itemSelected = data.filter((value, _) => {
        const arrayCurrent = itemCurrent.split('|');
        return (
          value.sku.toLowerCase() === arrayCurrent[1].trim().toLowerCase() &&
          value.name.toLowerCase() === arrayCurrent[0].trim().toLowerCase()
        );
      })[0];
    } else {
      itemSelected = data.filter((value, _) => {
        if (fieldOriginal.includes('|')) {
          const fieldArray = fieldOriginal.split('|');
          // eslint-disable-next-line eqeqeq
          return eval(`value.${fieldArray[0]}`) == itemCurrent.split(' | ')[0];
        }

        return eval(`value.${fieldOriginal}`) === itemCurrent;
      })[0];
    }

    if (isMultiple) {
      if (field === 'compatibility') {
        handleChangeCustom(field, { ...itemSelected, isCreate: true });
      }

      if (
        selectMultiple.filter((value) => value === itemCurrent).length > 0 ||
        itemCurrent === 'Selecione ...'
      ) {
        return;
      }

      selectMultiple.push(itemCurrent);
      setSelectMultiple(selectMultiple);

      return;
    }

    try {
      const position = Object.keys(itemSelected).findIndex(
        (item) => item === fieldOriginal
      );

      if (fieldOriginal === 'ref') {
        handleChangeTreeValues(
          field,
          Object.values(itemSelected)[position],
          'value',
          itemSelected.preco_venda,
          'weight',
          itemSelected.peso
        );
        setSelect(itemCurrent);
        return;
      }

      if (field === 'product' || field === 'tableOrder') {
        handleChangeCustom(field, itemSelected);
        setSelect(itemCurrent);
        return;
      }

      handleChangeCustom(field, Object.values(itemSelected)[position]);
      setSelect(itemCurrent);
    } catch (error) {
      setSelect(itemCurrent);
    }
  };

  const handleShowCustomSelectInObject = (value, fieldOriginal) => {
    if (fieldOriginal.includes('|')) {
      let fieldsToShow = fieldOriginal.split('|');
      return fieldsToShow
        .map((field) => {
          return value[field];
        })
        .join(' | ');
    }
    return eval(`value.${fieldOriginal}`);
  };

  const handleRemoveDataFromArray = (e) => {
    const itemCurrent = e.target.value;
    if (isMultiple && itemCurrent !== 'Selecione ...') {
      const itemSelected = data.filter((value, _) => {
        if (fieldOriginal.includes('|')) {
          const fieldArray = fieldOriginal.split('|');
          // eslint-disable-next-line eqeqeq
          return eval(`value.${fieldArray[0]}`) == itemCurrent.split(' - ')[0];
        }

        return eval(`value.${fieldOriginal}`) === itemCurrent;
      })[0];
      handleChangeCustom(field, { ...itemSelected, isCreate: false });
      const newArray = selectMultiple.filter((value) => {
        return value !== itemCurrent;
      });
      setSelectMultiple(newArray);
      return;
    }
  };

  return (
    <FormGroup>
      <label className='form-control-label' htmlFor='input-first-name'>
        {nameSelect} {icon && <i className={icon} id={tooltipName}></i>}
      </label>
      {descriptionTooltip && tooltipName && (
        <UncontrolledTooltip placement='right' target={tooltipName}>
          {descriptionTooltip}
        </UncontrolledTooltip>
      )}
      <Input
        type='select'
        onChange={handleOnChange}
        value={isMultiple ? selectMultiple : select}
        multiple={isMultiple}
      >
        <option value={undefined}>Selecione ...</option>
        {data.map((value, key) => {
          return (
            <option key={key} onDoubleClick={handleRemoveDataFromArray}>
              {fieldOriginal === undefined
                ? value
                : handleShowCustomSelectInObject(value, fieldOriginal)}
            </option>
          );
        })}
      </Input>
    </FormGroup>
  );
};

export const SelectItemGenericWithRequest = ({
  handleChangeCustom,
  field,
  fieldOriginal,
  fieldOnSave,
  nameSelect,
  pathUrl,
  valueJson,
}) => {
  const [select, setSelect] = useState(
    valueJson !== undefined && valueJson !== null ? valueJson.name : {}
  );
  const [data, setData] = useState([]);

  useEffect(() => {
    async function getData() {
      const data = await handleSendGeneric(pathUrl, 'GET');
      if (data !== undefined) {
        setData(data);
      }
      if (valueJson !== undefined && valueJson !== null) {
        setSelect(valueJson.name);
      }
    }

    getData();
  }, [pathUrl, valueJson]);

  const handleOnChange = (e) => {
    const itemCurrent = e.target.value;

    const itemSelected = data.filter((value, _) => {
      return eval(`value.${fieldOriginal}`) === itemCurrent;
    })[0];
    const position = Object.keys(itemSelected).findIndex(
      (item) => item === fieldOnSave
    );
    handleChangeCustom(field, { id: Object.values(itemSelected)[position] });
    setSelect(itemCurrent);
  };

  return (
    <FormGroup>
      <label className='form-control-label' htmlFor='input-first-name'>
        {nameSelect}
      </label>
      <Input type='select' onChange={handleOnChange} value={select}>
        <option>Selecione ...</option>
        {data.map((value, key) => {
          return <option key={key}>{eval(`value.${fieldOriginal}`)}</option>;
        })}
      </Input>
    </FormGroup>
  );
};
